import checkmarkIcon from 'assets/icons/checkmark.svg'
import { dimensionCards } from 'constants/BrandAssessmentConstants'

export const DimensionCards = () => {
  return (
    <div className="flex flex-col items-center gap-2.5 dimension-cards-container">
      <p className="title-l text-center">Dimensions used to assess status of core input areas</p>
      <p className="dimension-cards-subtitle body-s text-color-neutral-100 text-center">
        Across Human Insights, Product Edge & Brand Edge areas
      </p>
      <div className="dimension-cards">
        {dimensionCards.map(card => (
          <div key={card.title} className="dimension-card">
            <div className="flex flex-col self-stretch px-6 py-4 dimension-card-top-divider">
              <h3 className="dimension-card-title title-xxs">{card.title}</h3>
              <ul className="dimension-card-checks">
                {card.checks.map((segments, index) => (
                  <li key={index} className="dimension-card-check">
                    <img src={checkmarkIcon} alt="" className="dimension-card-check-icon" />
                    <span className="body-xs">
                      {segments.map((segment, segmentIndex) => (
                        <span key={segmentIndex} className={segment.bold ? 'font-bold' : undefined}>
                          {segment.text}
                        </span>
                      ))}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="dimension-card-divider">
              <p className="dimension-card-sources-label subtitle-xxs">{card.sourcesLabel}</p>
              <ul className="dimension-card-bullets body-xs">
                {card.sources.map(source => (
                  <li key={source}>{source}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
